import React, { useEffect } from "react";
import { Outlet, Navigate, useNavigate } from "react-router";
import portalConfig from "../configurations/gil.config";
import { useSelector } from "react-redux";

const PublicRoute = () => {
  const navigate=useNavigate()
  const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);


  const { authenticateEntryDep,authenticateEntryTrader,authenticateEntryPannel} = portalConfig


  //.log("Private Route - isAuthenticated:");

  const route = (
    roleIdentifier === "JC" || 
    roleIdentifier === "Dr" || 
    roleIdentifier === "COM" || 
    roleIdentifier === "DT" || 
    roleIdentifier === "SA" || 
    roleIdentifier === "SEC" || 
    roleIdentifier === "DY") ?
   authenticateEntryDep : roleIdentifier==="Tr"? authenticateEntryTrader : authenticateEntryPannel;



const token = useSelector((state: any) => state.auth.token);
let isAuthenticated = token;

  useEffect(() => {
    if (isAuthenticated) {
      //.log("Redirecting to private route:", route);
      navigate(route);
    } else {
      //.log("Redirecting");
      navigate("/");
    }
  }, [isAuthenticated, route, navigate]);

  return isAuthenticated ?  (<Navigate to={`${route}`} />) : <Outlet />;
};

export default PublicRoute;
